<template>
  <div>
    <p class="choosep">选择讲解语言</p>
    <div class="listboxf">
      <router-link  v-for="data,index in nums" :key="index"  :to="{ name:'Home',query: { a: data}}" >
          <span>{{data}}</span>
          <i class="iconfont icon-back"></i>
      </router-link >
    </div>
  </div>
</template>

<script>
export default {
    data(){
      let query=this.$route.query;
      let nums=query.a.split(",")
      return {
        nums:nums,
        names:{
          
        }
      }
    },
    components:{

    },
    computed:{

    },
    methods:{


    },
    created(){
    },
    mounted(){

    }
}
</script>

<style>
  .choosep{
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  .listboxf{
      display: flex;
      flex-direction: column;
  }
  .listboxf>a{
      width: 92%;
      margin-left: 4%;
      height: 12.6vw;
      line-height: 12.6vw;
      background-image: url(../assets/img/yinpinwenjianimg.png);
      background-size: auto 4.9vw;
      background-repeat: no-repeat;
      background-position: 0 center;
      border-bottom: 1px solid #e5e5e5;
  }
  .listboxf span{
      color: #333333;
      font-size: 3.5vw;
      margin-left: 7.2vw;
  }
  .listboxf i{
      float: right;
      font-size: 2.5vw;
      color: #666666;
      margin-right: .5vw;
  }
</style>



// WEBPACK FOOTER //
// src/view/choose.vue